import React from 'react';

const Play = ({ ...props }) =>
	<svg width="1em" height="1em" viewBox="0 0 47 47" {...props}>
		<path fill="#334849" fillRule="nonzero" d="M23.5,0 C10.5417083,0 0,10.5417083 0,23.5 C0,36.4582917 10.5417083,47 23.5,47 C36.4582917,47 47,36.4582917 47,23.5 C47,10.5417083 36.4582917,0 23.5,0 Z"/>
		<polygon fill="#FFF" points="17.625 33.292 17.625 13.708 33.292 23.5"/>
	</svg>;

export default Play;
